import { RestoreFromTrashSharp } from '@material-ui/icons';
import React from 'react';
import './../Css/Relatorio.css';
function HeaderRelatorio(props) {
    const {
        img,
        title,
        vendas,
        dataInicio,
        dataFim,
        formatCurrency,
        totalAdesaoPagas,
        totalMensalPagas,
        lengthAdesaoGeral,
        lengthMensalGeral,
    } = props;
    return (
        <div className='containerRelatorio'>
            <section className="container">
                <img src={img} alt="" className="logo1" />
                <div className="titulo">
                    <h1>Comissão de Vendas - {title}</h1>
                </div>
                <div className="content">
                    <ul></ul>
                </div>
                <div className="content2">
                    <ul>
                        <li className="item3">Total de vendas: {vendas}</li>
                        <li className="item2">
                            Data do Pagamento de {dataInicio} até {dataFim}
                        </li>
                    </ul>
                </div>
                <div className="content3">
                    <ul className="ul_adesao">
                        <li>
                            Total de Registro Adesão pagas: {lengthAdesaoGeral}
                        </li>
                        <li>
                            Comissão total de Adesão gerente:{' '}
                            {formatCurrency(totalAdesaoPagas)}
                        </li>
                    </ul>
                    <ul className="ul_mensal">
                        <li>
                            Comissão total de Mensalidade gerente:{' '}
                            {lengthMensalGeral}
                        </li>
                        <li>
                            Valor total de Mensalidades pagas:{' '}
                            {formatCurrency(totalMensalPagas)}
                        </li>
                    </ul>
                </div>
            </section>
        </div>
    );
}

export default HeaderRelatorio;
